


import React, { useState } from "react";
import CMSBlock from 'components/cms/CMSBLock';
import ContactForm from 'components/contact/ContactForm';
export default function PageContact() {

  return (
    <div>
      <CMSBlock
        blockId="page-contact-header"
        titleTag="h2"
        contentsClassName="container"
      />
      <div className="container py-5">
        <div className="row g-5">
          <div className="col-lg-5">
            <CMSBlock
              blockId="page-contact-content"
              titleTag="h2"
              contentsClassName="container"
            />
          </div>
          <div className="col-lg-7">
            <ContactForm />
          </div>
        </div>
      </div>
    </div>
  );
}